<!-- @format -->
<ng-container *ngIf="review">
	<div
		class="hmf-display-flex hmf-flex-column hmf-px-s hmf-px-lg-m hmf-pb-lg-s hmf-flex-lg-row review-section-container">
		<div
			class="hmf-mb-xs hmf-mb-lg-0 hmf-mt-lg-0 hmf-mr-lg-s hmf-display-flex hmf-align-items-flex-start hmf-justify-content-flex-start hmf-flex-column">
			<div class="large-slider hmf-display-flex hmf-flex-column">
				<div
					class="review-scroll-container hmf-position-relative hmf-display-flex hmf-align-items-center">
					<div
						*ngIf="media"
						class="hmf-position-relative hmf-display-flex scrollable-container hmf-align-self-start"
						[ngClass]="{ 'scrollable-container--not-scrollable': !activeScroll }">
						<button
							[ngClass]="{ enabled: isButtonLeft }"
							class="scroll-button scroll-button--left hmf-round-radius hmf-display-flex hmf-align-items-center hmf-justify-content-center"
							name="scroll-button-left"
							aria-label="Scroll left"
							[disabled]="sliderPositon === 0"
							(click)="buttonDirection('Left')">
							<homefield-icon
								name="chevron-left"
								fill="var(--hmf-label-secondary-static)"></homefield-icon>
						</button>
						<!-- media -->
						<product-reviews-review-media
							*ngIf="!media.video"
							[media]="media"
							[imageId]="imageId"
							[objectFit]="imageFit"
							[mediaSource]="mediaSource"></product-reviews-review-media>
						<iframe
							*ngIf="media.video"
							class="hmf-sharp-radius hmf-ml-lg-xl"
							width="100%"
							height="100%"
							[src]="safeUrl"
							[title]="media.video.Caption ?? 'Video for review ' + review.Title"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							loading="lazy"></iframe>
						<!-- media -->
						<button
							[ngClass]="{ enabled: isButtonRight }"
							class="scroll-button scroll-button--right hmf-round-radius hmf-display-flex hmf-align-items-center hmf-justify-content-center"
							name="scroll-button-right"
							aria-label="Scroll right"
							(click)="buttonDirection('Right')">
							<homefield-icon
								name="chevron-right"
								fill="var(--hmf-label-secondary-static)"></homefield-icon>
						</button>
					</div>
				</div>
			</div>
		</div>
		<div
			class="review-section-content hmf-display-lg-flex hmf-flex-lg-column hmf-align-items-flex-start hmf-justify-content-flex-start hmf-mt-md-s">
			<div
				*ngIf="review.Media.length > 1"
				class="thumbnails hmf-mb-lg-xxxs hmf-mt-lg-s">
				<product-reviews-review-thumbnails
					[mediaItem]="review"
					[selected]="photoSelected"
					(mediaSelected)="
						returnMediaSelected($event)
					"></product-reviews-review-thumbnails>
			</div>

			<div class="review-features hmf-mt-s hmf-mt-lg-0 fit-container">
				<p class="hmf-text-transform-capitalize hmf-mt-0 hmf-subheader-m">
					{{ review.UserNickname }}
				</p>
				<div
					class="hmf-display-flex hmf-align-items-center hmf-align-self-start hmf-justify-content-between hmf-mb-xs hmf-mt-0">
					<product-reviews-review-stars
						class="hmf-display-inline-flex"
						[rating]="review.Rating"
						[options]="starsOptions"></product-reviews-review-stars>
					<p class="user-info-badge hmf-ml-xxs hmf-body-s">
						{{ review.SubmissionTime | dateAgo }}
					</p>
				</div>
				<h4
					class="hmf-subheader-bold-m hmf-subheader-bold-lg-l hmf-text-transform-capitalize hmf-mb-xxs hmf-mt-0">
					{{ review.Title | titlecase }}
				</h4>
				<!-- review-badges -->
				<div
					class="badges-container hmf-mt-xxs hmf-mt-lg-xs"
					[ngClass]="{
						'hmf-display-flex hmf-align-self-start hmf-justify-content-start':
							!!review.BadgesOrder.length,
						'hmf-display-none': !review.BadgesOrder.length
					}">
					@for (
						badge of review.BadgesOrder;
						track trackByBadge($index, badge);
						let badgeIndex = $index
					) {
						<product-reviews-review-badges
							[ngClass]="{ 'hmf-mr-s': !badgeIndex }"
							[badgeType]="badge">
						</product-reviews-review-badges>
					}
				</div>

				<!-- features -->
				<product-reviews-review-features
					class="hmf-display-block hmf-mt-xxs hmf-mt-lg-xs"
					[review]="review"
					[smallFontFamily]="true"></product-reviews-review-features>

				<div *ngIf="review.TagDimensions.Pro?.Values">
					<p class="review-label hmf-mt-xs hmf-body-s">
						{{ review.TagDimensions.Pro.Values | splitContentPipe }}
					</p>
				</div>
			</div>

			<div class="review-about hmf-mt-xs">
				<!-- ReviewText -->
				<p
					*ngIf="review.ReviewText"
					class="review-text hmf-mb-xs hmf-body-m">
					{{ review.ReviewText }}
				</p>
				<!-- usedFor -->
				<div class="hmf-mb-xs">
					<product-reviews-review-features
						[review]="review"
						[filterByUsedFor]="true"
						[smallFontFamily]="false">
					</product-reviews-review-features>
				</div>

				<!-- Recommended -->
				<div
					*ngIf="review.IsRecommended"
					class="hmf-display-flex hmf-align-items-center hmf-align-self-start hmf-mb-xs">
					<homefield-icon
						width="16px"
						height="16px"
						name="sign-circled-check"
						class="hmf-mr-xxs"
						fill="var(--hmf-label-secondary-static)">
					</homefield-icon>
					<div class="review-label hmf-body-m">Yes, I recommend this product.</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>
